/**
 *   Generated file. Do not edit
 */

import { LocalTime } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getNtpServer: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/time/ntp-server',
    path: '/1024//77',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putNtpServer: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/time/ntp-server',
    path: '/1024//77',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getTimeZone: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/time/time-zone',
    path: '/1024//78',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putTimeZone: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/time/time-zone',
    path: '/1024//78',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getLocalTime: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/time/local-time',
    path: '/1024//79',
    responseBodyDecoder: allConverters.localTime,
  } as ServiceCallType<void, LocalTime>,
};
